import React, { useState, useEffect } from "react";
import Clientsidebar from "../components/Clientsidebar";
import Clientheader from "../components/Clientheader";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

function Helpcenter() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    const token = Cookies.get("token");
    console.log(token);
    if (!token) {
      // No token, redirect to home
      // navigate("/");
    } else {
      try {
        const decoded = jwtDecode(token);
        setUsername(decoded.username);
        setRole(decoded.role);

        // If the decoded role is not Client, redirect
        if (decoded.role !== "client") {
          // navigate("/");
        }
      } catch (error) {
        console.error("Invalid token");
        // navigate("/");
      }
    }
  }, [navigate]);

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      const fetchUserData = async () => {
        try {
          const token = Cookies.get("token");
          const response = await axios.get("https://api.easytaxexperts.com/client", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log(response.data);
        } catch (error) {
          console.error("Error:", error);
          if (error.response && error.response.status === 401) {
            // navigate("/");
          }
        }
      };

      fetchUserData();
    }
  }, [navigate]);

  return (
    <div className="client-grid-container">
      <Clientheader openSidebar={openSidebar} />
      <Clientsidebar
        openSidebarToggle={openSidebarToggle}
        openSidebar={openSidebar}
      />
      <main className="main-container mt-2">
        <div className="container">
          <div>
            <h4>Contact Us</h4>
            <p>Email:   info@easytaxexperts.com</p>
            <p>Phone: +1 (945)-358-4442</p>
          </div>
          <div>
            <p>Call or email us, we will reach out soon!</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Helpcenter;
